import { useAtom, useSetAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { asArray } from "../utils/helpers";

export const posTableFilterOptions = [
  {
    label: "showAllTables",
    value: 1,
  },
  {
    label: "showAvailableTables",
    value: 2,
  },
  {
    label: "showOccupiedTables",
    value: 3,
  },
];

export const posTableDisplaysOptions = [
  {
    label: "maps.map",
    value: true,
  },
  {
    label: "row",
    value: false,
  },
];

export const tableFilterAtom = atomWithStorage(
  "posTableFilter",
  posTableFilterOptions[0].value
);

export const filterPosTables = (tables, sessions, tableFilter) => {
  const list = tables ?? [];

  if (tableFilter === 1) {
    return list;
  }

  if (tableFilter === 2) {
    return list.filter(
      (table) =>
        sessions?.find((session) =>
          asArray(session.current_table_ids)?.includes(table.item_id)
        ) === undefined
    );
  }

  if (tableFilter === 3) {
    return list.filter((table) =>
      asArray(sessions).find(
        (session) =>
          asArray(session?.current_table_ids)?.includes(table.item_id) &&
          session.session_status !== 5 &&
          !session.is_removed
      )
    );
  }

  return list;
};

const usePosTableFilter = () => {
  const atom = useAtom(tableFilterAtom);
  return atom;
};

export const useSetPosTableFilter = () => useSetAtom(tableFilterAtom);

export default usePosTableFilter;
